import { SimpleLatLng } from "../Core";

const SQ_METERS_TO_SQ_FEET = 10.76391041671;
const GOOGLE_MAPS_TO_GOOGLE_EARTH_CONVERSION_FACTOR = 1.0024;

type computeAreaType = (
  path:
    | google.maps.LatLng[]
    | google.maps.LatLngLiteral[]
    | google.maps.MVCArray<google.maps.LatLng>,
  radius?: number,
) => number;

export function polygonArea(
  computeArea: computeAreaType,
  geometry: SimpleLatLng[][],
  inFeet: boolean = false,
): number {
  let totalArea = 0;
  let i = 0;

  // Calculate perimeter for all rings (outer boundary + holes)
  for (const ring of geometry) {
    // Create a closed path by adding the first point at the end if it's not already there
    const closedRing = [...ring];
    const firstPoint = ring[0];
    const lastPoint = ring[ring.length - 1];

    if (firstPoint.lat !== lastPoint.lat || firstPoint.lng !== lastPoint.lng) {
      closedRing.push(firstPoint);
    }

    const ringArea = computeArea(closedRing);
    totalArea = i == 0 ? ringArea : totalArea - ringArea;
    i++;
  }

  if (inFeet) {
    const rawValue =
      (totalArea * SQ_METERS_TO_SQ_FEET) /
      GOOGLE_MAPS_TO_GOOGLE_EARTH_CONVERSION_FACTOR;
    return Math.round(rawValue);
  }

  return Math.round(totalArea);
}
